// extracted by mini-css-extract-plugin
module.exports = {"grid":"SignUpPage_grid__wCsSv"};